import classNames from 'clsx';
import React, { useRef } from 'react';

import { PrizeInfo } from '@swf/casino';
import CurrencySymbol from '@swf/components/CurrencySymbol/CurrencySymbol';
import Translation from '@swf/components/Translation/Translation';
import fsbIcon from '@swf/core/assets/casino/free-spins.png';
import ibIcon from '@swf/core/assets/casino/instant-bonus-glow.png';
import { Currency } from '@swf/core/enums';
import type { PrizeDetail } from '@swf/core/types/CasinoRaces';
import { PrizeType } from '@swf/core/types/CasinoRaces';

import { TXTCLI_Prize, TXTCLI_Rank, TXTWCL_Prize_List } from './PayoutList.messages.json';
import styles from './PayoutList.scss';
import PrizeRow from './components/PrizeRow/PrizeRow';

interface Props {
  prizeDetails: PrizeDetail;
}

const PayoutList: React.FC<Props> = ({ prizeDetails }) => {
  const { compactPayouts } = prizeDetails;
  const scrollerRef = useRef<HTMLTableSectionElement>(null);
  const specialPrize =
    prizeDetails.prizeType === PrizeType.IB || prizeDetails.prizeType === PrizeType.FSB;
  const prizeRows =
    compactPayouts &&
    compactPayouts.map((payout, index) => (
      <PrizeRow key={index} payout={payout} details={prizeDetails} />
    ));

  return (
    <div className={styles.container}>
      <PrizeInfo prizeDetails={prizeDetails} />
      <div className={styles.title}>
        <Translation {...TXTWCL_Prize_List} />
      </div>
      <table
        className={classNames(specialPrize && styles.special, {
          [styles.ibPad]: prizeDetails.prizeType === PrizeType.IB,
          [styles.fsbPad]: prizeDetails.prizeType === PrizeType.FSB,
          [styles.cashPad]: [PrizeType.CASH, PrizeType.NONE].includes(prizeDetails.prizeType)
        })}
      >
        <thead>
          <tr>
            <th>
              <Translation {...TXTCLI_Rank} />
            </th>
            {
              <th>
                <Translation tagName="div" {...TXTCLI_Prize} />
                <div
                  className={classNames({
                    [styles.currency]: prizeDetails.prizeType !== PrizeType.NONE
                  })}
                >
                  {prizeDetails.prizeType === PrizeType.IB && (
                    <img className={styles.ibIcon} src={ibIcon} alt="" />
                  )}
                  {prizeDetails.prizeType === PrizeType.FSB && (
                    <img className={styles.fsbIcon} src={fsbIcon} alt="" />
                  )}
                  {prizeDetails.prizeType === PrizeType.CASH && (
                    <>
                      (
                      <CurrencySymbol
                        currency={prizeDetails ? prizeDetails.currency : Currency.USDollar}
                        trimSpace
                      />
                      )
                    </>
                  )}
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody ref={scrollerRef}>{prizeRows}</tbody>
      </table>
    </div>
  );
};

export default PayoutList;
